import React from 'react';
import EllipsisText from '../../common/components/EllipsisText';
type DescriptionLabelProps = {
    description: string;
    lineClamp?: number;
};

export default function DescriptionLabel({ description, lineClamp = 3 }: DescriptionLabelProps) {
    return <EllipsisText text={description} sx={{ fontSize: 'body2.fontSize' }} clampLines={lineClamp} />;
}
